import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const EditRevenueDialog = ({ open, onOpenChange, formData, onChange, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border border-white/10 sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>تعديل الإيراد</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">التاريخ</label>
            <Input
              type="date"
              value={formData.date}
              onChange={(e) => onChange({ ...formData, date: e.target.value })}
              className="bg-secondary/50 border-white/10"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">المبلغ</label>
            <div className="relative">
              <Input
                type="number"
                step="0.01"
                value={formData.amount}
                onChange={(e) => onChange({ ...formData, amount: e.target.value })}
                className="bg-secondary/50 border-white/10 pe-12"
                placeholder="0.00"
                required
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">د.إ</span>
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">عدد الزبائن</label>
            <Input
              type="number"
              min="1"
              value={formData.client_count}
              onChange={(e) => onChange({ ...formData, client_count: e.target.value })}
              className="bg-secondary/50 border-white/10"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">طريقة الدفع</label>
            <select
              value={formData.payment_method}
              onChange={(e) => onChange({ ...formData, payment_method: e.target.value })}
              className="w-full bg-secondary/50 border border-white/10 rounded-lg px-4 py-2"
            >
              <option value="cash">كاش</option>
              <option value="machine">مكينة</option>
            </select>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">ملاحظات</label>
            <Input
              type="text"
              value={formData.description}
              onChange={(e) => onChange({ ...formData, description: e.target.value })}
              className="bg-secondary/50 border-white/10"
              placeholder="ملاحظات إضافية..."
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button type="submit" className="flex-1 bg-primary text-primary-foreground">حفظ التعديلات</Button>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>إلغاء</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditRevenueDialog;
